// extracted by mini-css-extract-plugin
export default {"select":"versions_selector-module__select--1QcZr"};